import { createUpdateActionItemApi, getActionItemsApi } from 'api/actionItem';
import { ActionItem } from 'models/actionItem';

export const createActionItem = ({
  checkInInstanceId,
  competencyId,
  levelUpId,
  status,
  uiKey,
  dueTS,
  text,
  toIds,
  teams,
  label,
}) =>
  createUpdateActionItemApi({
    checkInInstanceId,
    competencyId,
    levelUpId,
    status,
    uiKey,
    dueTS,
    text,
    toIds,
    teams,
    label,
  }).then((res) => ActionItem.fromJSON(res.entity));

export const updateActionItem = ({ checkInInstanceId, status, uiKey, dueTS, text, toIds, teams, label, uuid }) =>
  createUpdateActionItemApi({
    checkInInstanceId,
    status,
    uiKey,
    dueTS,
    text,
    toIds,
    teams,
    label,
    uuid,
  }).then((res) => ActionItem.fromJSON(res.entity));

export const getActionItems = ({ checkInInstanceId, levelUpCompetencyId, agendaId, limit, offset }) =>
  getActionItemsApi({
    checkInInstanceId,
    levelUpCompetencyId,
    agendaId,
    limit,
    offset,
  }).then((res) => res.entity.map((actionItem) => ActionItem.fromJSON(actionItem)));
